import { ToastContainer as ReactToastifyContainer } from 'react-toastify'
import styled from 'styled-components'

import 'react-toastify/dist/ReactToastify.css'

import { Icon } from '@loadsmart/miranda-react'

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  appearance: none;
  cursor: pointer;
  align-self: center;
`

export function ToastContainer() {
  return (
    <ReactToastifyContainer
      icon={({ type }) => (
        <Icon
          name={type === 'success' ? 'check' : 'info'}
          color={type === 'success' ? 'color-success-60' : 'color-danger-60'}
        />
      )}
      closeButton={({ closeToast, type }) => (
        <StyledButton onClick={closeToast}>
          <Icon name="close" color={type === 'success' ? 'color-success-60' : 'color-danger-60'} />
        </StyledButton>
      )}
    />
  )
}
